import { Breadcrumb } from '@/components/Atoms/Breadcrumbs'
import { HasFeature } from '@/components/Atoms/Permissions'
import { Card, CardContent } from '@/components/ui/card'
import { UsersFeature } from '@/lib/features'
import { buildPath } from '@/routes'
import { Navigate, Outlet } from 'react-router'

export function UsersLayout() {
  return (
    <HasFeature
      feature={UsersFeature}
      noFeatureComponent={<Navigate to={buildPath('/')} />}
    >
      <Breadcrumb label="Users" path={buildPath('/users')} />

      <Card>
        <CardContent className="flex flex-col gap-4 lg:min-h-[500px]">
          <Outlet />
        </CardContent>
      </Card>
    </HasFeature>
  )
}
